module.exports = __webpack_public_path__ + "img/purple.be66260e.svg";